import http, { url } from '../../http'

const API_URL = "matriz_legal"

class matrizLegalAPI {

  async save(resource) {
    const response = await http(`${API_URL}/save`, 'POST', resource)
    return response
  }

  async saveI(resource) {
    const response = await http(`matriz_legal_implementation/save`, 'POST', resource)
    return response
  }

  async saveImplementacion(resource) {
    const response = await http(`matriz_legal_implementation/save`, 'POST', resource)
    return response
  }

  async updateImplementacion(id, resource) {
    const response = await http(`matriz_legal_implementation/update/${id}`, 'PUT', resource)
    return response
  }

  async getAll(id, page) {
    const response = await http(`matriz_legal?page=${page}`, 'POST')
    return response
  }
  
  async getAllImplementacion(id, page) {
    const response = await http(`matriz_legal_company/${id}?page=${page}`, 'POST')
    return response
  } 

  async get() {
    const response = await http(`${API_URL}`, 'POST')
    return response
  } 

  async listCompany(companieId) {
    const response = await http(`matriz_legal_company/${companieId}`, 'POST')
    return response
  } 

  async listTopicSearch(temaId, factorId) {
    const response = await http(`matriz_legal_company/topic_search/${temaId}/${factorId}`, 'POST')
    return response
  }

  async listTopicSearchPagination(temaId, factorId, page) {
    const response = await http(`matriz_legal_company/topic_search/${temaId}/${factorId}?page=${page}`, 'POST')
    return response
  }

  async getImplementacion2() {
    const response = await http(`matriz_legal_implementation/`, 'POST')
    return response
  } 

  async getImplementacion(id) {
    const response = await http(`matriz_legal_company/${id}`, 'POST')
    return response
  } 

/*   async getImplementacion() {
    const response = await http(`matriz_legal_implementation`)
    return response
  }  */

/*   async getAll(id, page) {
    const response = await http(`${API_URL}/companies/${id}?page=${page}`)
    return response
  }  */
 
  async getFactor(temaId) {
    const response = await http(`${API_URL}/associated_factor/${temaId}`)
    return response
  }

  async getTema() {
    const response = await http(`${API_URL}/topics`)
    return response
  }

  async getTipo() {
    const response = await http(`${API_URL}/standard_type`)
    return response
  }

  async getPension(id) {
    const response = await http(`${API_URL}/company/${id}`, 'POST')
    return response
  }

    async getShow(id) {
    const response = await http(`${API_URL}/${id}`)
    return response
  }

  async update(id, resource) {
    const response = await http(`matriz_legal_implementation/update/${id}`, 'PUT', resource)
    return response
  }

  async delete(id) {
    const response = await http(`${API_URL}/delete/${id}`, 'DELETE')
    return response
  } 
  
}

export default new matrizLegalAPI()